module.exports = __webpack_public_path__ + "media/images/light_grey_round_edge_sides-f839bed6f89101ee6b59f310cf2e4e55.svg";